import { render, staticRenderFns } from "./TeleconsultoPerFamiliare.vue?vue&type=template&id=daa4e8fe&"
import script from "./TeleconsultoPerFamiliare.vue?vue&type=script&lang=js&"
export * from "./TeleconsultoPerFamiliare.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports